import React from 'react';
import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
  delay?: number;
  show?: boolean;
  overflowY?: 'auto';
}

const StyledAnimationZoomIn = styled.div<Props>`
  opacity: ${(props) => (props.show ? '1' : '0')};
  transform: ${(props) => (props.show ? 'scale(1.0)' : 'scale(0.98)')};
  transition: opacity 0.5s, transform 0.7s;
  transition-timing-function: ease-out;
  ${({ overflowY }) =>
    overflowY &&
    `
    overflow-y: ${overflowY};
  `}
`;

export class AnimationZoomIn extends React.Component<Props> {
  state = {
    show: false,
  };

  private entryAnimationTimeout: any;

  componentDidMount() {
    const { delay } = this.props;

    this.entryAnimationTimeout = setTimeout(() => {
      this.setState({
        show: true,
      });
    }, (delay || 1) * 75 + 1);
  }

  componentWillUnmount() {
    clearTimeout(this.entryAnimationTimeout);
  }

  render() {
    const { children, overflowY } = this.props;
    const { show } = this.state;

    return (
      <StyledAnimationZoomIn overflowY={overflowY} show={show}>
        {children}
      </StyledAnimationZoomIn>
    );
  }
}
